const config = {
    id: 12,
    name: "视频",
    type: 1,
    module_code: "video",
    icon: "icon-tms-video",
    font_icon: "&#xe600;",
    style_type: 1,
    link_type: 0,
    property_data: {}
};
export default config;